import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../../Icons'

const CustomCardItems = ({
  onCardSelect = () => {},
  selectedCardId,
  cards = [],
  isService,
  isAdmin,
}) => {
  const { t } = useTranslation(['rewards-gift'])
  const navigate = useNavigate()

  return (
    <React.Fragment>
      {cards.length > 0 ? (
        <div className="custom-cards-container">
          {cards.map((element, index) => (
            <div
              className={`custom-card-item ${selectedCardId === element.id ? 'selected' : ''}`}
              key={`${element.name}_${index}`}
              onClick={() => onCardSelect(element)}
            >
              <img
                className="custom-card-item__image"
                src={element.cardImageUrl}
                alt={element.name}
              />
              <span className="custom-card-item__title">{element.name}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-cards-container">
          <Icon icon="searchLoading" />
          <span>
            {isService
              ? t('rewards-gift:customCardItems.noServicesFound')
              : t('rewards-gift:customCardItems.noAmenitiesFound')}
          </span>
          {isAdmin && (
            <button
              className="button button-primary"
              onClick={() =>
                navigate(
                  `/dashboard/${
                    isService
                      ? 'organisation/bookingtypes'
                      : 'building-dashboard/reservations/amenities'
                  }`,
                )
              }
            >
              {isService
                ? t('rewards-gift:customCardItems.addServiceButton')
                : t('rewards-gift:customCardItems.addAmenityButton')}
            </button>
          )}
        </div>
      )}
    </React.Fragment>
  )
}

CustomCardItems.propTypes = {
  onCardSelect: PropTypes.func,
  selectedCardId: PropTypes.number,
  cards: PropTypes.array,
  isService: PropTypes.bool,
  isAdmin: PropTypes.bool,
}

export default CustomCardItems
